'use client';

import React from 'react';

import { ErrorHandler } from '@lib/components/errorHandler';

type ErrorProps = {
  error: Error;
  reset: () => void;
};

const Error: React.FC<ErrorProps> = ({ error, reset }) => {
  return <ErrorHandler error={error} reset={reset} />;
};

export default Error;
